module.exports = __webpack_public_path__ + "static/media/cat-baby.b1a91998.svg";